export const affilations = [
  { label: 'Accountant', value: 'Accountant' },
  { label: 'Administrative Assistant', value: 'Administrative Assistant' },
  { label: 'CEO', value: 'CEO' },
  { label: 'CFO', value: 'CFO' },
  { label: 'CMO', value: 'CMO' },
  { label: 'COO', value: 'COO' },
  { label: 'CTO', value: 'CTO' },
  { label: 'Chairman', value: 'Chairman' },
  { label: 'Chief Accounting Officer', value: 'Chief Accounting Officer' },
  { label: 'Chief Business Officer', value: 'Chief Business Officer' },
  { label: 'Company Secretary', value: 'Company Secretary' },
  { label: 'Consultant', value: 'Consultant' },
  { label: 'Controller', value: 'Controller' },
  { label: 'Counsel', value: 'Counsel' },
  { label: 'Director, Board of Directors', value: 'Director, Board of Directors' },
  { label: 'Executive Assistant', value: 'Executive Assistant' },
  { label: 'Executive Director', value: 'Executive Director' },
  { label: 'General Counsel', value: 'General Counsel' },
  { label: 'Head of Investor Relations', value: 'Head of Investor Relations' },
  { label: 'Investor Relations', value: 'Investor Relations' },
  { label: 'Investor Relations, Manager', value: 'Investor Relations, Manager' },
  { label: 'Legal Counsel', value: 'Legal Counsel' },
  { label: 'Managing Director', value: 'Managing Director' },
  { label: 'President', value: 'President' },
  { label: 'Treasurer', value: 'Treasurer' },
  { label: 'Vice President', value: 'Vice President' },
  { label: 'Other', value: 'OTHER_PLACEHOLDER' }
];
